import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-vehicle.dto';
export * from './dtos/sell-vehicle-action.dto';
export * from './dtos/update-vehicle.dto';
export * from './dtos/vehicle-availability.dto';
export * from './dtos/vehicle-list.dto';
export * from './dtos/vehicle-record.dto';
export * from './dtos/vehicle-activity-event.dto';
export * from './dtos/vehicle-activity-event-hydration.dto';
export * from './dtos/vehicle-search.dto';
export * from './dtos/vehicle-public-search.dto';
export * from './dtos/vehicles-stats.dto';

export * from './enums/vehicle-action.enum';
export * from './enums/vehicle-allocation.enum';
export * from './enums/vehicle-body-type.enum';
export * from './enums/vehicle-drive-train-type.enum';
export * from './enums/vehicle-electric-battery-type.enum';
export * from './enums/vehicle-emissions-unit-co2.enum';
export * from './enums/vehicle-engine-cylinders-layout.enum';
export * from './enums/vehicle-engine-layout.enum';
export * from './enums/vehicle-engine-output-unit.enum';
export * from './enums/vehicle-engine-size-unit.enum';
export * from './enums/vehicle-fuel-tank-capacity-unit.enum';
export * from './enums/vehicle-list-action.enum';
export * from './enums/vehicle-movement-direction.enum';
export * from './enums/vehicle-odometer-unit.enum';
export * from './enums/vehicle-power-plant-type.enum';
export * from './enums/vehicle-type.enum';
export * from './enums/vehicle-status.enum';
export * from './enums/vehicle-steering-position.enum';
export * from './enums/vehicle-transmission-type.enum';
export * from './enums/vehicle-fuel-type.enum';

export * from './functions/vehicle-status-to-color.function';
export * from './functions/vehicle-to-make-full.function';
export * from './functions/vehicle-to-odometer-full.function';
export * from './functions/vehicle-to-series-trim-full.function';

export * from './types/vehicle-availability-params';
export * from './types/vehicles-filters';
export * from './types/vehicles-movement-filters';

export * from './validators/schemas/create-vehicle.schema';
export * from './validators/schemas/sell-vehicle-action.schema';
export * from './validators/schemas/update-vehicle-odometer.schema';
export * from './validators/schemas/update-vehicle.schema';

export const vehicleValidators = {
  canCreateOrUpdate,
  canPerformAction,
};
